import { SMBSelect } from './../components/input/smb-select';
import { Button, TextField, alpha, styled } from "@mui/material";

export const WhiteBorderTextField = styled(TextField)`
  & label {
    font-weight: bold;
    background-color: transparent!important;
  }
  & label[data-shrink='true'] {
    background-color: transparent!important;
    padding-left: 0;
    margin-left: -0.75rem;
  }
  & label.Mui-focused {
    color: white;
  }
  & .MuiOutlinedInput-root {
    margin-top: .75rem;
    background-color: ${({ theme }) =>alpha(theme.palette.info.light, .875)};
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.palette.grey[300]};
    }
    & > fieldset {
      border-color: ${({ theme }) => theme.palette.grey[600]};
    }
    &.Mui-focused fieldset {
      border-color: ${({ theme }) => theme.palette.grey[200]};
    }
  }
`;

export const WhiteBorderSMBSelect = styled(SMBSelect)`
  & svg {
    color: white;
  }
  & label {
    font-weight: bold;
    color: white;
    background-color: transparent!important;
  }
  & label.Mui-focused {
    color: white;
  }
  & label[data-shrink='true'] {
    background-color: transparent!important;
    padding-left: 0;
    margin-left: -0.75rem;
  }
  & .MuiOutlinedInput-root {
    margin-top: .75rem;
    background-color: ${({ theme }) =>alpha(theme.palette.info.light, .875)};
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.palette.grey[500]};
    }
    & > fieldset {
      border-color: ${({ theme }) => theme.palette.grey[600]};
    }
    &.Mui-focused fieldset {
      border-color: ${({ theme }) => theme.palette.grey[200]};
    }
  }
  & .MuiOutlinedInput-input {
    color: white;
  }
`;

export const WhiteBorderSMBButton = styled(Button)`
  color: white;
  border: 1px solid white;
  &:hover {
    background-color: ${({ theme }) =>alpha(theme.palette.info.light, .875)};
    border: 1px solid white;
  }
`;
